import { render } from "./ListOrder.vue?vue&type=template&id=316a240b"
import script from "./ListOrder.vue?vue&type=script&lang=js"
export * from "./ListOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__